import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MarchiComponent } from './marchi.component';
import { MarchiListComponent } from './marchi-list/marchi-list.component';
import { MarchiCreateComponent } from './marchi-create/marchi-create.component';
import {MarchiDetailsComponent} from './marchi-details/marchi-details.component';
import {MarchiEditComponent} from './marchi-edit/marchi-edit.component';
import { MarchiListBlobsComponent } from './marchi-list-blobs/marchi-list-blobs.component';
import { MarchiListPdfComponent } from './marchi-list-pdf/marchi-list-pdf.component';
const routes: Routes = [
    {
        path : '',component: MarchiComponent, children: [
            {
                path: '',component: MarchiListComponent

            },
            {
                path: 'create', component: MarchiCreateComponent

            },
            {
                path: 'details/:id',
                component: MarchiDetailsComponent

            },
            {
                path: 'edit/:id',
                component: MarchiEditComponent

            },
            {
              path: 'list-pdf', component:MarchiListPdfComponent

            },
            {
              path: 'marchi-list-blobs',
              component: MarchiListBlobsComponent

          }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MarchiRoutingModule { }
